import { round } from "lodash"

const numberWithCommas = (x: number | string) => {
  const parts = x.toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return parts.join(".")
}

const numberFormat = (value: number, decimalPoint: number) => {
  const convertValue = value ? value.toString().replace(/,/g, "") : value

  return numberWithCommas((round(Number(convertValue), decimalPoint) || 0).toFixed(decimalPoint))
}

export { numberWithCommas, numberFormat }
